import { render, staticRenderFns } from "./vipRights2022.vue?vue&type=template&id=547918d8&scoped=true&"
import script from "./vipRights2022.vue?vue&type=script&lang=js&"
export * from "./vipRights2022.vue?vue&type=script&lang=js&"
import style0 from "./vipRights2022.vue?vue&type=style&index=0&id=547918d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547918d8",
  null
  
)

export default component.exports